import type { Direction } from "@/core/types";
import type { DirectionHandler, InputSource, PauseToggleHandler } from "./InputSource";
import { getAudioManager } from "@/audio/AudioManager";

const KEY_TO_DIRECTION: Record<string, Direction> = {
  ArrowUp: "up",
  ArrowDown: "down",
  ArrowLeft: "left",
  ArrowRight: "right",
};

const NAVIGATION_KEYS = new Set([
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  " ",
  "Spacebar",
]);

/** Keyboard control: arrow keys to steer, Space to pause/resume. */
export class KeyboardInput implements InputSource {
  private readonly onKeyDown = (event: KeyboardEvent): void => {
    getAudioManager().unlock();
    if (NAVIGATION_KEYS.has(event.key)) {
      // Stop the browser from scrolling the page while playing.
      event.preventDefault();
    }

    const direction = KEY_TO_DIRECTION[event.key];
    if (direction) {
      this.onDirection(direction);
      return;
    }

    if (event.key === " " || event.key === "Spacebar") {
      this.onPauseToggle();
    }
  };

  constructor(
    private readonly onDirection: DirectionHandler,
    private readonly onPauseToggle: PauseToggleHandler,
  ) {}

  start(): void {
    window.addEventListener("keydown", this.onKeyDown, { passive: false });
  }

  stop(): void {
    window.removeEventListener("keydown", this.onKeyDown);
  }
}
